import * as Sentry from '@sentry/browser';

import { getAppConfig } from 'utils/config';

export const sentryInitializer = () => {
  Sentry.init({ dsn: getAppConfig('SENTRY_DSN') });
};
